////////////////////////////////////////////////////////////////////////////////
// BIGGEST TODOS:
// -  Doku: Seitenansicht vs. config.js
// -  Doku: fields, preferences und deren defaults
// -  Doku: NEVER set "save history" for Preferences
// -  Doku: 
//
////////////////////////////////////////////////////////////////////////////////
// Problems of Rule:
// - Rule has NO OPT_OUT
// - API and Rule's database are not in sync!
// - missing data and/or identifiers in webhook payloads
// - API spams sensible data and must be filtered by Azure Management API!
// - :id can't be used in templates
// - :email can be used with any endpoint except PUT subscribers
////////////////////////////////////////////////////////////////////////////////
//
// Problems with this app:
// - it is generally crap! nearly everything had to be changed a few days before go live
// - the whole process is a bunch of workarounds for infrastructural problems
// - Formik and Yup was a bad choice for this. Should be removed!
// - create reusable objects!!!!!
//
////////////////////////////////////////////////////////////////////////////////
// LASTMOD:
// 20200728, SB: GDPR checkbox removed
// 20200813, SB: handle submit button! Extended form validation.
//              THIS IS A DIRTY HACK! Need to get rid of Yup!
// 20210428, SB: fixed + in e-mail in URL params
// 20210429, SB: additive on subscribe mode! Don't send inactive (see MARKE_SUPPRESSED)
// 20210715, SB: minified checkboxes
import React from "react";
import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BarLoader from 'react-spinners/BarLoader';   // spinner for loading
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/AccountSetup.css';
import './formComponents.js';
import Select from 'react-select';
import { findValidPrefs, getDynamicStates } from './dataHelperFunctions.js';
import { Checkbox, TextInput, AlertUser, Radiobutton } from './formComponents.js';
import { config } from './config.js';
import { Collapse } from 'reactstrap';
import Footer from "./components/Footer";
import Header from "./components/Header";

// TODO: empty für "settings" view
// TODO: GET RID OF Yup! 
let validation = Yup.object({
  firstName: Yup.string().max(50, "max. 50 Buchstaben möglich").required("Pflichtfeld"),
  lastName: Yup.string().max(50, "max. 50 Buchstaben möglich").required("Pflichtfeld"),
  email: Yup.string().email("E-Mail-Adresse ungültig").required("Pflichtfeld"),
})


////////////////////////////////////////////////////////////////////////////////
// signup form  
class SignupForm extends React.Component {
  // Constructor: inits state for form values and corresponding JSON
  constructor(props) {
    super(props);

    // parameter queries
    const query = new URLSearchParams(window.self.location.search);
    const account_id = query.get("account_id");
    let subscriber = query.get("subscriber") ? query.get("subscriber") : 0;

    // 20210428, SB: Bugfix: got + in e-mail as a %20. 
    // There are no other "reserved" chars but + allowed, so I can just substitute:
    if (subscriber) {
      subscriber = subscriber.replace(/\s/g, '+');
    }

    // get portal setup from config; by account_id
    const portal = { ...config.portals[account_id] };

    // change favicon according to portal
    const favicon = document.querySelector('[rel=icon]');
    favicon.href = portal.favicon;

    // get generates states according to account info
    this.state = getDynamicStates(account_id, portal, subscriber);

    // INITIAL AJAX call: fetch subscribers settings by ID
    // on "Account Settings" only! Not for "Subscribe!"
    this.apiGetSettings(subscriber);

    // drop validation for SETTINGS mode
    if (this.state.mode === "setup") {
      validation = null;
      // this.state.disableSubmit = false; // 20200813, SB: handle submit button
    }

    // Bind 'this' context to handler function to pass it to child component
    this.handleAlerts = this.handleAlerts.bind(this);
  } // END: constructor
  /////////////////////


  ////////////////////////////////////////
  // create dynamic form values for Formik
  getInitialFormValues = () => {
    let returnVals = {
      SUPPRESSED: this.state.SUPPRESSED, // 'unsubscribe all' checkbox
      cbDailyMail: this.state.cbDailyMail, // 'daily mails' checkbox
      // for mode 'subscribe' only
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      //acceptedTerms: false, // 20200728: not needed anymore
      title: "keine Angabe",
    };

    // add dynamic STATES for topicMails
    // creates: EM_RN_BVB: this.state.EM_RN_BVB,
    for (let i in this.state.portal.topicMails) {
      returnVals[this.state.portal.topicMails[i].key] = this.state[this.state.portal.topicMails[i].key];
      //console.log("initial dynamic_topicMails: ",i, ":", this.state.portal.topicMails[i].key, this.state[this.state.portal.topicMails[i].key] );
    }
    // add dynamic STATES for specialMails
    for (let i in this.state.portal.specialMails) {
      returnVals[this.state.portal.specialMails[i].key] = this.state[this.state.portal.specialMails[i].key];
      //console.log("initial dynamic_specialMails: ",i, ":", this.state.portal.specialMails[i].key, this.state[this.state.portal.specialMails[i].key] );
    }

    return returnVals;
  };


  // API-call to fetch the subscribers setting from rule.se
  // GET https://lensingmedia.azure-api.net/rule/rn/subscribers/:identifier
  apiGetSettings = (subscr) => {
    // skip fetch for subscriber mode
    if (this.state.mode === "subscribe") {
      // TODO: "Can't call setState on a component that is not yet mounted" without setTimeout!?
      setTimeout(() => {
        this.setState({ fetchInProgress: false });
      }, 1000);
      return;
    }

    // build API-URL
    //const apiUrl = this.state.portal.apis.subscriber + subscr + "/fields?identified_by=id";
    const apiUrl = this.state.portal.apis.subscriber + subscr + "/fields?identified_by=" + this.state.identifier;

    // start API-call
    axios
      .get(apiUrl)
      .then((response) => {
        console.log("apiGetSettings:", apiUrl, " : ", response);

        // search for subscribers data in json reply
        for (var i = 0; i < response.data.groups.length; i++) {
          // search response for Preferences
          if (response.data.groups[i].name === "Preferences") {
            var preferences = [];
            preferences = response.data.groups[i].fields;

            // MARKE_MULTI: push values to select!?
            var chosenCities = []; // this.state.selectedCities;

            for (var j = 0; j < preferences.length; j++) {
              // console.log("ALL FIELDS: ", preferences[j].name, "=>", preferences[j].value);
              // collect active abonnements
              if (preferences[j].value === "active") {
                console.log("GOT ACTIVE FIELD BY API: >",preferences[j].name,"<  >",preferences[j].value,"<");

                this.setState({ [preferences[j].name]: true }); // this.state.EM_RN_BVB: true

                // 20200813, SB: remember loaded checkboxes as checked for handling submit
                // 20200813, SB: FIXME TODO: WARNING!
                // eslint-disable-next-line no-loop-func
                this.setState(prevState => ({ checkedNewsletters: prevState.checkedNewsletters.set(preferences[j].name, true) }));
                //console.log("state on load NEWSLETTERS: ####################:", this.state.checkedNewsletters);

                // set cbDailyMail if current is one of the daily mails
                if (this.state.portal.dailyMails.keys.indexOf(preferences[j].name) > -1) {
                  this.setState({ cbDailyMail: true });     // set daily checkbox!
                  console.log("PREFS RECEIVED, CITIES, KEYS: ", preferences, chosenCities, this.state.portal.dailyMails.selects[this.state.portal.dailyMails.keys.indexOf(preferences[j].name)]);

                  // TODO: check index by .selects but the keys-array!!
                  chosenCities.push(this.state.portal.dailyMails.selects[this.state.portal.dailyMails.keys.indexOf(preferences[j].name)]);
                }
              }
            }
          }
        }

        // fill city dropdown
        this.setState({ selectedCities: chosenCities });

        // ... and show dropdown if needed
        if (this.state.portal.dailyMails.keys.length > 1) {
          this.setState({ showDailySelect: true }); 
        }
        //console.log("state after init: ", this.state);

        // remove fetchInProgress barloader
        setTimeout(() => {
          this.setState({ fetchInProgress: false });
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });


    // Rule sets suppression on EVERYTHING at link-click in e-mail footers. WHY!?
    // DELETE suppression if I didn't actually set the pref
    // MARKE_SB TODO FIXME: Remove, when switched to email as ID!! Unsubscribe-Links in Rule are changed. 
    // if (!this.state.SUPPRESSED) {
    //   const suppURL = this.state.portal.apis.suppressions + this.state.subscriber + '?identified_by=id';
    //   //https://lensingmedia.azure-api.net/rule/rn/suppressions/149166839?identified_by=id
    //   axios.delete(suppURL)
    //     .then((response) => {
    //       console.log("apiGetSettings - DEL suppression:", suppURL, " : ", response);
    //     })
    //     .catch((error) => {
    //       console.log("ERR: DEL suppression", error);
    //     });
    // }

    // https://lensingmedia.azure-api.net/rule/brs/subscribers/:id/?identified_by=email
    if (this.state.identifier === "email") {
      const subscrURL = this.state.portal.apis.subscribers + this.state.subscriber + "?identified_by=email";

      axios
        .get(subscrURL)
        .then((response) => {
          console.log("apiGetSettings - GET subscriber:", subscrURL, " : ", response);
          console.log(">>>>>>>>>>>>>>>>>>> ", response.data.subscriber.id);
          this.setState({ subscriber: response.data.subscriber.id });
          this.setState({ identifier: "id" });
        })
        .catch((error) => {
          console.log("ERR: GET subscriber", error);
        });
    }

  }; // END: apiGetSettings
  ////////////////////////


  ////////////////////////////////////////////////////////
  // API-call to update the subscribers setting at rule.se
  // PUT https://lensingmedia.azure-api.net/rule/rn/subscribers/:identifier
  apiUpdateSubscriber = () => {
    //console.log("state_to_send:", this.state);
    //console.log("fields_to_send:", this.state.fields);
    this.setState({ fetchInProgress: true });

    const reqURL = this.state.portal.apis.subscribers + this.state.subscriber;
    const suppURL = this.state.portal.apis.suppressions;

    // get the whole set inactivated fields of preferences
    let newFields = []; 

    // get valid preferences and set their values, if not 'unsubscribe all'
    // otherwise just send the inactivated defaults
    newFields = findValidPrefs(this.state);

    // DELETE suppression
    if (!this.state.SUPPRESSED) {
      //const suppURL = this.state.portal.apis.suppressions + this.state.subscriber + '?identified_by=id';
      const suppURL = this.state.portal.apis.suppressions + this.state.subscriber + '?identified_by=' + this.state.identifier;
      //https://lensingmedia.azure-api.net/rule/rn/suppressions/149166839?identified_by=id
      axios.delete(suppURL)
        .then((response) => {
          console.log("apiUpdateSubscriber - DEL suppression:", suppURL, " : ", response);
        })
        .catch((error) => {
          console.log("ERR: DEL suppression", error);
        });
    }
    
    // register suppressions if SUPPRESSED
    // 20200813, SB: FIX: form not updated!? //if (form.SUPPRESSED)
    if (this.state.SUPPRESSED) {
      //let jsonSuppr = { "subscribers": [{ "id": this.state.subscriber }], "suppress_on": { "campaign": ["email"] } };
      let jsonSuppr = { "subscribers": [{ "id": this.state.subscriber }], "suppress_on": { "campaign": ["email"], "transaction": ["email"] } };
      axios.post(suppURL, JSON.stringify(jsonSuppr), { headers: { "Content-Type": "application/json" } })
        .then((response) => { console.log("RESPONSE ON SUPPRESSION:", response); })
        .catch((error) => { 
          console.log(error);
          this.setState({ message: { type: "warning", txt: "Bei der Abmeldung ist ein Fehler unterlaufen. Sollte dieses Problem weiterhin bestehen, wenden Sie sich bitte an "+ this.state.portal.footer.mailto_ls } });
        });

      this.setState({ message: { type: "success", txt: "Sie wurden von allen Newslettern abgemeldet." } });
    }

    // MARKE_BUG XXX TOPIC MAILS FAIL!!:
    // this.setState({ fields: newFields }); // TODO: check this!
    //console.log("apiUpdateSubscriber pref_to_send: ", reqURL, JSON.stringify(newFields));
    window.schneepflug('trackStructEvent','rule', this.state.mode, this.state.account_id, this.state.subscriber, JSON.stringify(newFields));

    // TODO: catch errors
    axios
      .put(reqURL, '{"fields":' + JSON.stringify(newFields) + "}", { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        console.log("apiUpdateSubscriber reply:", reqURL, " : ", response);

        // TODO FIXME? can get OLD values even after the API confirmed the new ones after PUT!
        // looks like I get a positive reply before the database operation or COMMIT of open transaction
        // this.apiGetSettings(this.state.apiGetSettingsUrl);
        this.setState({ fetchInProgress: false });
      })
      .catch((error) => {
        console.log(error);
      });
      this.setState({ message: { type: "success", txt: "Ihre Newslettereinstellungen wurden erfolgreich geändert." } });
  }; // END: apiUpdateSubscriber
  /////////////////////////////

  /////////////////////////////////////////////////
  // API-call to create new subscription at rule.se
  // PUT https://lensingmedia.azure-api.net/rule/rn/subscribers/:identifier
  apiCreateSubscriber = (form) => {
    this.setState({ fetchInProgress: true });

    // URL to API endpoint: POST /subscribers
    const reqURL = this.state.portal.apis.subscribers;

    // MARKE_BUG
    const newFields = findValidPrefs(this.state);

    // unshift Kontaktdaten to fields
    newFields.unshift({ key: "Kontaktdaten.Nachname", value: form.lastName, type: "text" });
    newFields.unshift({ key: "Kontaktdaten.Vorname", value: form.firstName, type: "text" });
    newFields.unshift({ key: "Kontaktdaten.Anrede", value: form.title, type: "text" });

    //console.log("apiCreateSubscriber pref_to_send: ", reqURL, newFields);

    var jsonSubscr = {
      update_on_duplicate: true, // update "resubscribers"
      tags: ["Newsletter"], // tags to subscribe to
      // automation: "reset", // toggle automations every time
      require_opt_in: true, // opt-in (triggered only once)
      async: true,          // internal server error at "resubscribe" without async!?
      subscribers: {
        email: form.email,
        language: "de",
        fields: newFields, // {key: "Preferences.EM_RN_DO", value: "inactive"}
      },
    };
    // console.log("subscribers_json", jsonSubscr);

    // track sent JSON //window.schneepflug('trackSelfDescribingEvent', {jsonSubscr});
    window.schneepflug('trackStructEvent','rule', this.state.mode, this.state.account_id, form.email, JSON.stringify(newFields));

    // TODO: catch errors, show messages
    axios
      .post(reqURL, JSON.stringify(jsonSubscr), { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        this.setState({ message: { type: "success", txt: "Vielen Dank für Ihre Newsletteranmeldung. Falls Sie bisher noch keine Newsletter von uns erhalten, haben wir einen Bestätigungslink an Ihre E-Mail-Adresse geschickt." } });

        // Successfully created/updated subscriber, when ID found in response
        if (response.data.subscriber.id) {
          console.log("DID I GET AN ID?? >>> ", response.data.subscriber.id);
          // set subscriber for  switching to setup-mode
          this.setState({ subscriber: response.data.subscriber.id });
          // switch to setup-mode
          this.setState({ mode: "setup" });
          // drop validation schema to enable submit
          validation = null;
        }

        this.setState({ fetchInProgress: false });

        // DEL suppressions for re-subscribers
        // This is not okay! Rule doesn not send OptIn-request again! Remove? 
        // If removed, remove also at MARKE_SUPPRESSED in dataHelperFunctions !!
        //const suppURL = this.state.portal.apis.suppressions + response.data.subscriber.id + '?identified_by=id';
        const suppURL = this.state.portal.apis.suppressions + response.data.subscriber.id + '?identified_by=' + this.state.identifier;
        axios.delete(suppURL)
          .then((response) => {
            console.log("apiUpdateSubscriber - DEL suppression:", suppURL, " : ", response);
          })
          .catch((error) => {
            console.log("ERR: DEL suppression", error);
          });

      })
      .catch((error) => {
        console.log(error);
        this.setState({ message: { type: "warning", txt: error.message } });
        this.setState({ fetchInProgress: false });
      });
  }; // END: apiCreateSubscriber
  /////////////////////////////

  ////////////////////////////
  // handle generic checkboxes
  onCheckboxChange = (event) => {
    // 20200813, SB: keep checkbox values
    var checked = event.target.checked;
    var name = event.target.name;

    // 20200813, SB: keep checkbox values for activating submit
    if (name !== 'SUPPRESSED') {
      // 20200813, SB: FIXME: CAUSES WARNING!!!
      this.setState(prevState => ({ checkedNewsletters: prevState.checkedNewsletters.set(name, checked) }));
      //console.log("state onCheckboxChange NEWSLETTERS: ####################:", this.state.checkedNewsletters);
    } // else { console.log("state onCheckboxChange SUPPRESSED!!!!:", name,  this.state.checkedNewsletters); }

    // toggle box state
    this.setState({ [event.target.name]: event.target.checked });
    //console.log("CHECK:", event.target.name, event.target.checked);

    // 20200813, SB: handle submit 
    setTimeout(() => { blockSubmit(this); }, 300);
  };

  /////////////////////////////
  // handle the daily Checkbox
  onDailyCheckboxChange = (event) => {
    const name = event.target.name;
    const checked = event.target.checked;
    console.log("CHECK:", name, checked);
    const toggle = !this.state.cbDailyMail;
    let singleCity = false;

    this.setState({ cbDailyMail: toggle }); // toggle box

    // If there is only one daily mail, add it and enable submit! Otherwise show dropdown
    if (this.state.portal.dailyMails.keys.length === 1) {
      this.setState({ selectedCities: this.state.portal.dailyMails.selects[0] });
      singleCity = true;
    } else {
      this.setState({ showDailySelect: toggle });
    }

    // 20200813, SB: keep checkbox values
    // daily mail is only true, if city is chosen, too!! Or if only one city exists (no dropdown!)
    if (
        (this.state.selectedCities && this.state.selectedCities.length > 0 && checked)
        || (singleCity && checked)
      ) {
      this.setState(prevState => ({ checkedNewsletters: prevState.checkedNewsletters.set(name, checked) }));
    } else {
      this.setState(prevState => ({ checkedNewsletters: prevState.checkedNewsletters.set(name, false) }));
    }

    // 20200813, SB: handle submit 
    setTimeout(() => { blockSubmit(this); }, 300);
    console.log("states:", this.state.cbDailyMail, this.state.ddChooseCity);
  };

  /////////////////////////////
  // handle the "alle abbestellen" unsubscribe checkbox
  onSuppressNlChange = (event) => {
    this.setState({ SUPPRESSED: !this.state.SUPPRESSED }); // toggle box
    blockSubmit(this); // 20200813, SB: handle submit
  };

  /////////////////////////////
  // handle the daily dropdown
  onSelectChange = (selectedCities) => {
    let bSelected = Boolean(selectedCities);
    // set selected value
    this.setState({ selectedCities });
    //console.log("SELECTED OPTION: ", selectedCities);

    // toggle "daily" checkbox when no city selected
    if (selectedCities) {
      this.setState({ cbDailyMail: true });
      this.setState({ showDailySelect: true });
    } else {
      this.setState({ cbDailyMail: false });
      this.setState({ showDailySelect: false });
    }
    // 20200813, SB: handle submit after declaring cbDailyMail "checked" und nl active here and now: 
    // console.log("CITY SELECTED: ", bSelected);
    this.setState(prevState => ({ checkedNewsletters: prevState.checkedNewsletters.set('cbDailyMail', bSelected) }));
    setTimeout(() => { blockSubmit(this); }, 300);
  };


  // Toggle state of messages. This method will be sent to the child component <AlertUser>
  handleAlerts = () => {
    this.setState({ message: { type: "success", txt: 0 } });
  };


  ////////////////////////////////////////////////////////////////////////////////
  render() {

    return (
      <>
        {
          // allways show messages first
          this.state.message.txt ? (
            <AlertUser
              type={this.state.message.type}
              txt={this.state.message.txt}
              action={this.handleAlerts}
            ></AlertUser>
          ) : (
            <> </>
          )
        }

        {
          // loading screen while ajax running
          this.state.fetchInProgress ? (
            <div className="container fill">
              <div className="row h-100">
                <div className="col-sm-12 my-auto">
                  Daten werden geladen ...
                  <BarLoader size={250} color={"#009ee0"} />
                </div>
              </div>
            </div>
          ) : (
            ////////////////////////////////////
            // content, when no loading screen
            <>
              <div className="container bg-white">
                <Header portal={this.state.portal} />

                <Formik
                  //enableReinitialize // send state changes to formik!
                  initialValues={this.getInitialFormValues()}
                  /* mapPropsToValues={this.getInitialFormValues()} */
                  validationSchema={validation}
                  onSubmit={(formValues, { setSubmitting }) => {
                    // 20200813, SB: echt jetzt?
                    //if (blockSubmit(this) ) { //  //setSubmitting(false); //  //validation = null; // not validate again //  return; //}
                    setTimeout(() => {
                      this.state.mode === "setup"
                        ? this.apiUpdateSubscriber(formValues)
                        : this.apiCreateSubscriber(formValues);
                    }, 400);

                    setSubmitting(false);
                  }}
                >
                  <Form autoComplete="off">
                    <Collapse isOpen={!this.state.SUPPRESSED}>
                      <div className="m-4">
                        <p className="h2">
                          Ihre Newsletter {this.state.portal.name.art_genitiv} {this.state.portal.name.full}
                        </p>
                      </div>

                      {/** 20210720, SB: Zeitsteuerung für Aktionen BEGIN */}
                      {this.state.aktionActive ? (
                        <div className="ml-4 mr-4 mb-3 pr-2 row">
                          <span>
                            {/** TODO: Farbe nach Portal wählen!! **/}
                            {/** <strong style={{ color: "#009EE0" }}> **/}
                            <strong style={{ color: "#00A550" }}>
                              {this.state.portal.aktion.text}
                              <a href={this.state.portal.aktion.url}>{this.state.portal.aktion.url_text}</a>{" "}
                            </strong>
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                      {/** 20210720, SB: Zeitsteuerung END */}

                      {/** 202104, SB: original Headline (was substituted by temp. Bauer announcement) */}
                      <div className="ml-4 mr-4 pr-2 row">
                        <span>
                          {" "}
                          <strong>{this.state.portal.introHead}</strong>{" "}
                        </span>
                      </div>
                      <div className="ml-4 mr-4 pr-2 row">
                        <span>Unsere <strong>Erinnerungs-, Angebots-, Vorteils- und Empfehlungsnewsletter</strong> können Sie wie gewohnt auf dieser Seite abbestellen. Entfernen Sie einfach das Häkchen bei den Newslettern, die Sie nicht mehr erhalten möchten, und klicken Sie anschließend auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.</span>
                      </div>
                      {/** Anmelde-Infotext */}
                      {this.state.mode === "subscribe" ? (
                        <>
                          <div className="ml-4 mt-4 pr-2 row">
                            <span>
                              {" "}
                              <strong>{this.state.portal.subscrInfoHead}</strong>{" "}
                            </span>
                          </div>
                          <div className="ml-4 pr-2 row">
                            <span>{this.state.portal.subscrInfoText} </span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {/* * Setup-Infotext
                      {this.state.mode === "setup" ? (
                        <>
                          <div className="ml-4 mt-4 pr-2 row">
                            <span>
                              {" "}
                              <strong>{this.state.portal.setupInfoHead}</strong>{" "}
                            </span>
                          </div>
                          <div className="ml-4 pr-2 row">
                            <span>Unsere <strong>Angebots-, Vorteils-, Sonntags- und Empfehlungsnewsletter</strong> können Sie wie gewohnt auf dieser Seite abbestellen. Entfernen Sie einfach das Häkchen bei den Newslettern, die Sie nicht mehr erhalten möchten, und klicken Sie anschließend auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.</span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )} */}
                      {this.state.portal.dailyMails.keys.length > 0 ? (
                        <>
                          <div className="m-4 row">
                            <p className="h2">Ihre Newsletter-Auswahl:</p>
                          </div>
                          <div className="row m-4">
                            <h2>{this.state.portal.dailyMailsHead}</h2>
                          </div>
                          <div className="row">
                            <div className="col-md-4 mb-sm-5 mx-auto">
                              <img
                                className="rounded-circle mx-auto d-block"
                                width="50%"
                                src={this.state.portal.dailyMails.imgUrl}
                                alt={this.state.portal.dailyMails.name}
                              />
                            </div>
                            <div className="col-md-8 mt-4">
                              <Checkbox
                                id="cbDailyMail"
                                name="cbDailyMail"
                                className="checkBox"
                                onChange={this.onDailyCheckboxChange}
                                checked={this.state.cbDailyMail}
                              >
                                {" "}
                                {this.state.portal.dailyMails.name}
                              </Checkbox>
                              <div className="text-muted font-weight-bold">
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 24 24"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {" "}
                                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z">
                                    {" "}
                                  </path>{" "}
                                </svg>{" "}
                                {this.state.portal.dailyMails.time}
                              </div>
                              <div className="mr-md-5"> {this.state.portal.dailyMails.text} </div>
                              <Collapse isOpen={this.state.showDailySelect}>
                                <div className="w-md-75">
                                  <Select
                                    placeholder="bitte wählen..."
                                    name="ddChooseCity"
                                    isMulti
                                    onChange={this.onSelectChange}
                                    value={this.state.selectedCities}
                                    options={this.state.portal.dailyMails.selects}
                                    closeMenuOnSelect="false"
                                  ></Select>
                                </div>
                              </Collapse>
                            </div>
                          </div>{" "}
                          {/* END: row */}
                        </>
                      ) : (
                        <></>
                      )}
                      {this.state.portal.topicMails.length > 0 ? (
                        <div className="row m-4">
                          {" "}
                          <h2>Themen Newsletter</h2>{" "}
                        </div>
                      ) : (
                        <></>
                      )}
                      {this.state.portal.topicMails.map((mail) =>
                        /** "minified" entries are meant to be a group of checkboxes without own pics and texts */
                        mail.minify ? (
                          <div key={mail.key}>
                            {/** ONE of the "minify" group might have a text, wich is meant to be a headline - show it, if existing: */}
                            {mail.text ? (
                              <div key="dummy01" className="row justify-content-center mb-1">
                                {" "}
                                <div className="col-md-4"></div> <div className="col-md mr-5 mt-3">{mail.text}</div>{" "}
                              </div>
                            ) : (
                              <></>
                            )}

                            {/** "minify" group of checkboxes without pics and texts */}
                            <div key={mail.key} className="row justify-content-center">
                              <div className="col-md-4"> </div>
                              <div className="col-md-8">
                                <div className="row">
                                  <div className="m-0 p-0">
                                    <Checkbox
                                      id={mail.key}
                                      name={mail.key}
                                      className="checkBox ml-3"
                                      onChange={this.onCheckboxChange}
                                      checked={this.state[mail.key]}
                                    >
                                      {" "}
                                      {mail.name}
                                    </Checkbox>
                                  </div>
                                  <div className="m-0 p-0">
                                    <svg
                                      className="text-muted ml-2"
                                      stroke="currentColor"
                                      fill="currentColor"
                                      strokeWidth="0"
                                      viewBox="0 0 24 24"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      {" "}
                                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z">
                                        {" "}
                                      </path>{" "}
                                    </svg>{" "}
                                    <small className="text-muted">{mail.time}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          /** the normal ones; if not "minified"  */
                          <div key={mail.key}>
                            <div className="row justify-content-center mt-4">
                              <div className="col-md-4">
                                <img
                                  className="rounded-circle mx-auto d-block"
                                  width="50%"
                                  src={mail.imgUrl}
                                  alt={mail.name}
                                />
                              </div>
                              <div className="col-md-8 mt-4">
                                <label>
                                  <Checkbox
                                    id={mail.key}
                                    name={mail.key}
                                    className="checkBox"
                                    onChange={this.onCheckboxChange}
                                    checked={this.state[mail.key]}
                                  >
                                    {mail.name}
                                  </Checkbox>
                                </label>
                                <div className="text-muted font-weight-bold">
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 24 24"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    {" "}
                                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z">
                                      {" "}
                                    </path>{" "}
                                  </svg>{" "}
                                  {mail.time}
                                </div>
                                <div className="mr-md-5"> {mail.text} </div>
                              </div>
                            </div>{" "}
                          </div>
                        )
                      )}
                      <hr />
                      <Collapse isOpen={this.state.mode === "setup"}>
                        {this.state.portal.specialMails.map((mail) => (
                          <div key={mail.key}>
                            <div className="row ml-md-4 mr-4">
                              <div className="col">
                                <div className="d-flex w-100 justify-content-between">
                                  <Checkbox
                                    id={mail.key}
                                    name={mail.key}
                                    className="checkBox"
                                    onChange={this.onCheckboxChange}
                                    checked={this.state[mail.key]}
                                  >
                                    {mail.name}
                                  </Checkbox>
                                </div>
                                <p className="mb-1">{mail.text}</p>
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Collapse>
                    </Collapse>

                    {this.state.mode === "setup" ? (
                      <>
                        <div className="row">
                          <div className="col" align="center">
                            Sie möchten keinen der vier Newsletter mehr erhalten?
                          </div>
                        </div>
                        <div className="row">
                          <div className="col" align="center">
                            <Checkbox
                              id="SUPPRESSED"
                              name="SUPPRESSED"
                              className="checkBox"
                              onChange={this.onCheckboxChange}
                              checked={this.state.SUPPRESSED}
                            >
                              {" "}
                              Alle Newsletter abbestellen
                            </Checkbox>
                          </div>
                        </div>
                      </>
                    ) : (
                      <> </>
                    )}

                    {/** SUBSCRIBE MODE ONLY */}
                    {this.state.mode === "subscribe" ? (
                      <div className="row mt-5 subscribe">
                        <div className="m-4">
                          <p className="h3">Kontaktdaten angeben und anmelden:</p>
                        </div>

                        <div className="container">
                          <div className="row m-2 justify-content-md-center">
                            <div className="col-md-2"></div>
                            <div className="col-md">
                              <Radiobutton label="Anrede" name="title" values={["Frau", "Herr", "keine Angabe"]} />
                            </div>
                            <div className="col-md-2"></div>
                          </div>

                          <div className="row m-2 justify-content-md-center">
                            <div className="col-md-2"></div>
                            <div className="col-md">
                              <TextInput
                                className="form-control input-sm"
                                label="Vorname"
                                name="firstName"
                                type="text"
                                placeholder="Vorname"
                              />
                            </div>
                            <div className="col-md">
                              <TextInput
                                className="form-control input-sm"
                                label="Nachname"
                                name="lastName"
                                type="text"
                                placeholder="Nachname"
                              />
                            </div>
                            <div className="col-md-2"></div>
                          </div>

                          <div className="row m-2 justify-content-md-center">
                            <div className="col-md-2"></div>
                            <div className="col">
                              <TextInput
                                className="form-control input-sm"
                                label="E-Mail-Adresse"
                                name="email"
                                type="email"
                                placeholder="muster@mail.de"
                              />
                            </div>
                            <div className="col-md-2"></div>
                          </div>

                          <div className="row m-1">
                            <div className="col-md-2"></div>
                            <div className="col">
                              {" "}
                              <p name="acceptedTerms" className="text-wrap">
                                {" "}
                                Durch Angabe meiner Daten (Vorname, Nachname, E-Mail-Adresse) und Anklicken des Buttons
                                „Kostenlos anmelden“ erkläre ich mich damit einverstanden, dass der{" "}
                                {this.state.portal.footer.copyright} mir regelmäßig Informationen in den ausgewählten
                                Newslettern per E-Mail zuschickt. Um den Newsletter für Sie zu optimieren, willigen Sie
                                in unsere Auswertung ein. Meine Einwilligung kann ich jederzeit unter{" "}
                                <a href={this.state.portal.footer.mailto}>{this.state.portal.footer.mailto}</a>{" "}
                                widerrufen. Weitere Informationen zu der Protokollierung Ihrer Anmeldung, der
                                statistischen Auswertung, dem Versandverfahren sowie Ihren Abbestellmöglichkeiten
                                (Widerruf), erhalten Sie in unserer{" "}
                                <a
                                  className="hl"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={this.state.portal.footer.links_bottom[1].url}
                                >
                                  Datenschutzerklärung
                                </a>{" "}
                                .
                              </p>
                            </div>
                            <div className="col-md-2"></div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <> </>
                    )}

                    <div
                      className={
                        this.state.mode === "subscribe"
                          ? "row text-center justify-content-center subscribe"
                          : "row mt-5 text-center justify-content-center"
                      }
                    >
                      <div className={this.state.mode === "subscribe" ? "container subscribe" : "container"}>
                        <div className="row m-1">
                          <div className="col">
                            {/** 20200813, SB: handle activating submit */}
                            {/** <button type="submit" className="btn btn-success" disabled={this.state.disableSubmit} >  */}
                            <button
                              type="submit"
                              className={
                                this.state.portal.footer.classCta
                                  ? "btn " + this.state.portal.footer.classCta
                                  : "btn btn-success"
                              }
                              disabled={this.state.disableSubmit}
                            >
                              {this.state.mode === "subscribe"
                                ? "Kostenlos anmelden"
                                : "Newsletter-Änderungen speichern"}
                            </button>
                            {this.state.disableSubmit && this.state.mode === "subscribe" ? (
                              <div className="error">Bitte wählen Sie mindestens einen Newsletter</div>
                            ) : (
                              <> </>
                            )}
                            {this.state.disableSubmit && this.state.mode === "setup" ? (
                              <div className="error">Keine Änderungen vorhanden oder keine Newsletter gewählt </div>
                            ) : (
                              <> </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </Formik>
              </div>
              <Footer portal={this.state.portal} year={this.state.year} className="subscribe" />
            </>
          ) // END: if not loading screen
        }
      </>
    );
  }
}

function AccountSetup() {
  return <SignupForm />;
}

// 20200813, SB: find active newsletters to activate submit on subscribe mode
function blockSubmit(e) {
  //console.log("SUPPRESSED: ", e.state.SUPPRESSED);
  //console.log("ANY CHECKED? : ", e.state.checkedNewsletters);

  // enable on SUPPRESSED!!
  if (e.state.SUPPRESSED) {
    e.setState({ disableSubmit: false }); // MARKE_SUBMIT 
    return true;
  }

  // if a newsletter is chosen, return false - dont' disable submit
  for (let [key, value] of e.state.checkedNewsletters.entries() ) {
    // console.log("BLABLABLAKEY", key + ' = ' + value)
    if (value) {
      e.setState({ disableSubmit: false }); // MARKE_SUBMIT 
      console.log("unblock submit: active nl:", key + ' = ' + value)
      return false;
    }
  }

  // if NO newsletter is chosen, return true to disable submit!
  e.setState({ disableSubmit: true }); // MARKE_SUBMIT 
  return true;
}

export default AccountSetup;